import React from 'react';
import service from 'axios';
import { siteApi } from '../Utils';
import MenuTemplate1 from './MenuTemplate1';
import MenuTemplate2 from './MenuTemplate2';
import MenuTemplate3 from './MenuTemplate3';
import NotFoundPage from './NotFoundPage';

const componentsMap = {
  1: MenuTemplate1,
  2: MenuTemplate2,
  3: MenuTemplate3,
};

export default function MenuPage({ match, location }) {
  const branchId = new URLSearchParams(location.search).get('u');
  const companyName = match.params.companyname;
  const [company, setCompany] = React.useState(null);
  const [error, setError] = React.useState(null);
  React.useEffect(() => {
    service
      .get(`${siteApi}webmusteri/getCompanyInfo`, {
        params: { branchId, companyName }
      })
      .then(res => setCompany(res.data.Data))
      .catch(err => setError(err));
  }, [branchId]);

  if (error) return <NotFoundPage />;
  if (!company) return <NotFoundPage />;

  const key = company.QrMenuTasarim;
  const Component = componentsMap[key];

  return Component
    ? <Component match={match} location={location} company={company} />
    : <NotFoundPage />;
}
